/* eslint-disable max-classes-per-file */
export class CustomError extends Error {
  public code: null | string = null;

  constructor(message: string) {
    super(message);
    this.code = message;
  }
}

export class FirebaseAuthError extends CustomError {
  public customData: Record<string, string> = {};

  constructor(message: string, customData: Record<string, string>) {
    super(message);
    this.customData = customData;
  }
}
